export default __webpack_public_path__ + "img/d434b596fb5c2539c7690b1c2dd21e0d.png";